export const addHours = (from, hoursToAdd) => new Date(from.getFullYear(), from.getMonth(), from.getDate(), from.getHours() + hoursToAdd, from.getMinutes(), from.getSeconds());
export const addDays = (from, daysToAdd) => new Date(from.getFullYear(), from.getMonth(), from.getDate() + daysToAdd, from.getHours(), from.getMinutes(), from.getSeconds());
export const DateRangeMapper = {
    OneHour: (from) => addHours(from, 1),
    TwoHours: (from) => addHours(from, 2),
    ThreeHours: (from) => addHours(from, 3),
    SixHours: (from) => addHours(from, 6),
    TwelveHours: (from) => addHours(from, 12),
    OneDay: (from) => addDays(from, 1),
    TwoDays: (from) => addDays(from, 2),
    ThreeDays: (from) => addDays(from, 3),
    SevenDays: (from) => addDays(from, 7)
};
//# sourceMappingURL=DateRangeMapper.js.map